/* eslint-disable */
import React, { Component} from 'react';
import {getTestRunStatusForCADTopology} from "../UserFunctions"
import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import 'react-data-table-component-extensions/dist/index.css';

class CadTestRun extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            cad_uuid : '',
            tag_name : ''
        }
    }

    componentDidMount(){
        document.getElementsByClassName('print')[0].style.visibility = 'hidden';
        document.getElementsByClassName('download')[0].style.visibility = 'hidden';
        
        if (localStorage.cad_uuid != undefined)
        {
            var payload = {
                cad_uuid : localStorage.cad_uuid
            }
        }
        else
        {
            var payload = {
                cad_uuid : ''
            }
        }
        
        console.log("Local storage:",localStorage.cad_uuid)
        getTestRunStatusForCADTopology(payload).then(res => {
            console.log("CAD test run data : ",res.data)
            console.log("res . data : ",res.data)
            this.setState( prevState => {
                return{
                    ...prevState,
                    data: res.data.data,
                    cad_uuid : localStorage.cad_uuid,
                    tag_name : res.data.tag_name
                }
            })
    })
    }


    render() {
        const columns = [
            {
                name: 'Job ID',
                selector: 'job_id',
                sortable: true,
                left: true,
                grow : 2
            },
            {
                name: 'Status',
                selector: 'status',
                sortable: true,
                center: true
            },
            {
                name: 'Test Run ID',
                selector: 'test_run_id',
                sortable: true,
                center: true
            },
            {
                name: 'Test Point ID',
                selector: 'test_point_id',
                sortable: true,
                center: true
            },
        ]
        const tableData = {
            columns,
            data: this.state.data
        }
        const customStyles = {
            rows: {
                style: {
                    backgroundColor: '#C7C9FF !important',
                    color : '#464646',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    borderBottom: '12px solid #FFFFFF',
                }
            },
            headCells: {
                style: {
                    backgroundColor: 'white',
                    color: '#464646',
                    borderBottom: '4px solid #622AD8',
                    textAlign: 'center',
                }
            }
        }
        console.log("This.state.data:",this.state.data)

        return (
            <div className='container-fluid'>
                <div className='row' style={{ 'paddingTop': '3%' }}>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                <h4>Topology Test Run Status</h4>
                            </div>
                            <div><h2 style={{fontWeight: 'bold'}}>Topology ID</h2> <p>{this.state.cad_uuid}</p></div>
                            <div><h2 style={{fontWeight: 'bold'}}>Tag name</h2><p>{this.state.tag_name}</p></div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <DataTableExtensions
                                            {...tableData}
                                        >
                                            <DataTable
                                                pagination
                                                customStyles={customStyles}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CadTestRun;